/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/18
 */
import './index.css';
import React,{Component} from 'react';
import classname from 'classname';

class Input extends Component {
  constructor (props) {
    super(props);
    this.prefixCls = 'store-input';
  }
  getWrapInput () {
    return <span className={`${this.prefixCls}-group-wrapper`}>
      <span className={`${this.prefixCls}-group`}>
        {this.props.prefix
          ? <span className={`${this.prefixCls}-group-addon`}>{this.props.prefix}</span>
          : ''
        }
        {this.getInput()}
        {this.props.suffix
          ? <span className={`${this.prefixCls}-group-addon`}>{this.props.suffix}</span>
          : ''
        }
      </span>
    </span>
  }
  focus() {
    this.refs.input.focus();
  }

  blur() {
    this.refs.input.blur();
  }
  getInput () {
    const { size, disabled, placeholder, className, error } = this.props;
    const cls = classname(this.prefixCls, className,{
      [`${this.prefixCls}-sm`]: size === 'small',
      [`${this.prefixCls}-lg`]: size === 'large',
      [`${this.prefixCls}-disabled`]: disabled,
      [`${this.prefixCls}-error`]: error
    });
    const props = Object.assign({}, this.props);
    if (props.suffix) {
      delete props.suffix
    }
    if (props.prefix) {
      delete props.prefix
    }
    return <input
      {...props}
      className={cls}
      placeholder={placeholder}
      ref="input"
    />
  }
  render () {
    if (this.props.prefix || this.props.suffix) {
      return this.getWrapInput();
    } else {
      return this.getInput();
    }
  }
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/lib/input/index.js